/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Faq5a_Supportlink2Inputs */

const zh_pricing_faq5a_supportlink2 = /** @type {(inputs: Pricing_Faq5a_Supportlink2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`联系客服`)
};

const en_pricing_faq5a_supportlink2 = /** @type {(inputs: Pricing_Faq5a_Supportlink2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`contact Support`)
};

const es_pricing_faq5a_supportlink2 = /** @type {(inputs: Pricing_Faq5a_Supportlink2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`contactar a Soporte`)
};

/**
* | output |
* | --- |
* | "contact Support" |
*
* @param {Pricing_Faq5a_Supportlink2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const pricing_faq5a_supportlink2 = /** @type {((inputs?: Pricing_Faq5a_Supportlink2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Faq5a_Supportlink2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_pricing_faq5a_supportlink2(inputs)
	if (locale === "en") return en_pricing_faq5a_supportlink2(inputs)
	return es_pricing_faq5a_supportlink2(inputs)
});
export { pricing_faq5a_supportlink2 as "pricing_faq5A_supportLink" }